import gql from 'graphql-tag';

export const PRODUCT_SEARCH_BY_ID = gql`
  query SearchForProductByID($id: String!, $salesOrg: String) {
    product(id: $id, salesOrg: $salesOrg) {
      id
      description
      salesOrg
    }
  }
`;

export const PRODUCT_SEARCH_BY_NAME = gql`
  query SearchForProductByName($name: String!, $salesOrg: String) {
    productSearchByName(name: $name, salesOrg: $salesOrg) {
      id
      description
      group
      salesOrg
    }
  }
`;
